import { PDFOptionsForm } from "../lib/types/ReportDownload.type"

export const FONTS = ['Helvetica', 'Times', 'Courier', 'Arial']
export const HEADER_SIZES = ['6', '8', '10', '12', '14', '16', '18']
export const HEADER_STYLES = ['Regular', 'Italics', 'Bold', 'Bold Italics']
export const POSITIONS = ['Left', 'Center', 'Right']
export const SWATCHES = ['#000000', '#993300', '#333000', '#003300', '#003366', '#000080', '#333399', '#333333', '#800000', '#FF6600', '#808000', '#008000', '#008080', '#0000FF', '#666699', '#808080', '#FF0000', '#FF9900', '#99CC00', '#339966', '#33CCCC', '#3366FF', '#800080', '#969696', '#FF00FF', '#FFCC00', '#FFFF00', '#00FF00', '#00FFFF', '#00CCFF', '#993366', '#C0C0C0', '#FF99CC', '#FFCC99', '#FFFF99', '#CCFFCC', '#CCFFFF', '#99CCFF', '#CC99FF', '#FFFFFF']
export const DEFAULT_HEADER_FONT = 'Times'
export const DEFAULT_HEADER_SIZE = '12'
export const DEFAULT_HEADER_STYLE = 'Regular'
export const DEFAULT_HEADER_POSITION = 'Center'
export const DEFAULT_HEADER_COLOR = '#000000'

export const INITIAL_VALUES: PDFOptionsForm = {
  paper_size: 'USLetter',
  font_size: 8,
  orientation: 'portrait',
  header_has_logo: 'first_page_only',
  header1_text: '',
  header1_font: DEFAULT_HEADER_FONT,
  header1_font_size: DEFAULT_HEADER_SIZE,
  header1_font_style: DEFAULT_HEADER_STYLE,
  header1_position: DEFAULT_HEADER_POSITION,
  header1_color: DEFAULT_HEADER_COLOR,
  header2_text: '',
  header2_font: DEFAULT_HEADER_FONT,
  header2_font_size: DEFAULT_HEADER_SIZE,
  header2_font_style: DEFAULT_HEADER_STYLE,
  header2_position: DEFAULT_HEADER_POSITION,
  header2_color: DEFAULT_HEADER_COLOR,
  footer_text: '',
  footer_font: DEFAULT_HEADER_FONT,
  footer_font_size: DEFAULT_HEADER_SIZE,
  footer_font_style: DEFAULT_HEADER_STYLE,
  footer_position: DEFAULT_HEADER_POSITION,
  footer_color: DEFAULT_HEADER_COLOR,
  footer_date: true,
  footer_page_numbers: true,
  date_position: 'Left',
  page_number_position: 'Right',
  top_margin: 0.5,
  bottom_margin: 0.5,
  left_margin: 0.5,
  right_margin: 0.5
}
